<p-accordion [styleClass]="classesToAdd" [multiple]="multipleOpen" (onOpen)="accordionOpen.emit($event);">
    <p-accordionTab *ngFor="let tmpl of templates; let i = index" [header]="headersarray[i]"
        [ngClass]="{'filtered': filteredData[filterDetails[headersarray[i]].filter_key]?.length}">
        <ng-container [ngTemplateOutlet]="tmpl"></ng-container>
    </p-accordionTab>
</p-accordion>